import styled, { css } from "styled-components";

// export const ArticleImage = styled.div`
//       border-radius: 10px;
//       width: 320px;
//       height: 350px;
//       background-color: black;
//       margin: "7px"
// `
export const ArticleImage = styled.img`
  ${(props) => {
    switch (props.mode) {
      case "text":
        return css`
          border-radius: 10px;
          object-fit: cover;
          width: 100%;
          height: 350px;
          margin: "7px";
        `;
      case "audio":
        return css`
          border-radius: 10px;
          margin-bottom: 15px;
        `;
      default:
        return css`
          border-radius: 30px;
          width: 100%;
          height: 450px;
          marginleft: 5px;
          background-color: red;
          margin: 7px;
        `;
    }
  }}
`;
